<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author LiangGangQiang
// Date 2021-08-19 16:46:21

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";

export default {
    name: "sithMesPrdManBorrowProcessWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdManBorrowProcess/complete-feedback";
        },
        config() {
            return {
                'task_borrow': {
                    name: '借用申请',
                    variables: [
                        {
                            label: '借用原因',
                            name: 'borrowReason',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            repeat: true,
                            labelWithName: {
                                'borrowDateFrom': '借用开始时间',
                                'borrowDateTo': '借用结束时间',
                            },
                            type: this.VALUE_TYPE.DATETIME,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        }
                    ],
                    userSelectMap: {
                        '*': [
                            {
                                name: 'task_approve',
                                isAssignee: true,
                                require: true
                            },
                            {
                                name: 'email_cc',
                                labelWithout: 'Email Cc',
                                allowMulti: true
                            },
                            {
                                name: 'borrowUser',
                                labelWithout: '人员借用',
                                allowMulti: true,
                                saveToDatabase: true,
                                require: true
                            }
                        ]
                    },
                    putByApprove: () => {
                        return {
                            url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdManBorrowProcess/selective",
                            entity: {
                                id: this.$_emWorkflowTaskMixin_businessKey,

                            }
                        };
                    },
                    approveToNextTask: 'task_approve'
                },
                'task_approve': {
                    name: '借用批准',
                    approveLabel: '是否批准',
                    userSelectMap: {
                        1: [{
                            name: 'approveUser',
                            labelWithout: '借用批准',
                            initData: true,
                            initDataName: 'borrowUser',
                            allowMulti: true,
                            saveToDatabase: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_return',
                        2: 'Event_end'
                    }
                },
                'task_return': {
                    name: '借用归还',
                    approveToNextTask: 'Event_end'
                },
                'Event_end': {
                    name: '结束'
                },
            };
        }
    }
};
</script>